import api from "utils/apiService";

const queryString = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

export const quotationApi = {
  listContractorAdmin: (filters) =>
    api.get(`/contractorQuotations/admin${queryString(filters)}`),
  listSupplierAdmin: (filters) =>
    api.get(`/supplierQuotations/admin${queryString(filters)}`),
  deleteContractor: (id) => api.delete(`/contractorQuotations/${id}`),
  deleteSupplier: (id) => api.delete(`/supplierQuotations/${id}`),
  getContractor: (id) => api.get(`/contractorQuotations/${id}`),
  getSupplier: (id) => api.get(`/supplierQuotations/${id}`),
};
